import { Stack, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useNavigate } from 'react-router-dom';
import { Paths } from 'services/navigation/paths';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';

export const SourcingExternalSuccessStep = () => {
  const navigate = useNavigate();
  const selectedRows = useSourcingExternalStore((state) => state.selectedRows);
  const candidateBatch = useSourcingExternalStore(
    (state) => state.candidateBatch
  );
  const onInit = useSourcingExternalStore((state) => state.onInit);
  const { track } = useTracking();
  return (
    <Stack gap="30px" maxWidth="500px" mx="auto">
      <Typography variant="title">Done!</Typography>
      <Typography variant="subTitle">
        The {selectedRows.length} candidate
        {selectedRows.length !== 1 ? 's have ' : ' has '}
        been added to the "invited" tab within your analysis.
      </Typography>
      <Stack direction="row" gap="20px">
        <Button
          variant="primary"
          onClick={() => {
            navigate(
              `${Paths.ANALYSE}/${candidateBatch?.id}?tab=Source_candidates`
            );
          }}
        >
          View invited candidates
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            if (candidateBatch) {
              track(TrackingEventName.SourcingSuccessFindMoreCandidates, {
                candidateBatchId: candidateBatch.id
              });
              onInit(candidateBatch);
            }
          }}
        >
          Source more candidates
        </Button>
      </Stack>
    </Stack>
  );
};
